export function normalizeAdminGroups(value) {
  const raw = Array.isArray(value) ? value : typeof value === 'string' ? [value] : [];
  return raw
    .map((entry) => String(entry || '').trim().toLowerCase())
    .filter(Boolean);
}

export function hasAdminAccess(appUser, area) {
  if (!appUser) return false;
  const groups = normalizeAdminGroups(appUser.adminGroups);
  const requestedArea = area == null ? '' : String(area).trim().toLowerCase();
  if (!requestedArea) return groups.length > 0;
  return groups.includes(requestedArea) || groups.includes('all');
}
